export function validateAndGet(inputId, parseFunction, validationFunction, errorMessage) {
  const value = parseFunction(document.getElementById(inputId).value)
  if(isNaN(value) || !validationFunction(value)) {
    throw(errorMessage)
  }
  return value
}